'use client';
import React, { useState } from 'react';
import Image from 'next/image';
import LinesEllipsis from 'react-lines-ellipsis';

export default function StoryComp({ story }) {
  const [useEllipsis, setUseEllipsis] = useState(true);

  const readMoreClickAction = (e) => {
    if (e) e.preventDefault();
    setUseEllipsis(!useEllipsis);
  };
  return (
    <div className="testimony-item">
      <h3>{story.title}</h3>
      <div className="testimony-comment more">
        {useEllipsis ? (
          <>
            <span className="morecontent">
              <LinesEllipsis
                text={story.body}
                maxLine="5"
                ellipsis="..."
                trimRight
                basedOn="letters"
              />
              <a href="#" className="morelink" onClick={readMoreClickAction}>
                Read more...
              </a>
            </span>
          </>
        ) : (
          <>
            <span className="morecontent">
              {story.body}
              <a href="#" className="morelink" onClick={readMoreClickAction}>
                Read less...
              </a>
            </span>
          </>
        )}
      </div>
      <div className="author">
        <div className="author-pic">
          <Image
            src={story.authorPic}
            alt={story.authorName}
            width="60"
            height="60"
          />
        </div>
        <div className="author-info">
          <div className="name">{story.authorName}</div>
          <div className="position">{story.authorTitle}</div>
        </div>
      </div>
    </div>
  );
}
